import React from 'react';
import { Input, Button, PaperClip, Select, Textarea, Table, Tooltip } from 'components';
import { QuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { connect } from 'react-redux';
import moment from 'moment';
import { EyeBlackIcon, AlertIcon } from 'assets/icons';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		item: { ...this.props.item },
		header: [
			'Fecha de recepción',
			'Clínica',
			'Ciudad',
			'Acción'
		]
	}

	view = async (_item: any, index: number) => {
		let item = {...this.state.item};
		item.responses[index].viewed = Constants.QUOTE_RESPONSE_VIEWED.VIEWED;
		await this.setState({
			item
		});
		await QuoteService.doctor.view({
			response_id: _item?.id,
			withoutLoading: true
		});
	}
	
	render() {
		return (
			<div id="modal-doctor-view-quote">
				<h3>Cotizaciones recibidas</h3>
				{
					this.state.item?.responses.length > 0 && (
						<Table data={ this.state.item?.responses?.length } header={ this.state.header }>
							{
								this.state.item?.responses?.map((item: any, index: number) => {
									return (
										<tr>
											<td>
												{
													item.viewed == Constants.QUOTE_RESPONSE_VIEWED.NOT_VIEWED && (
														<Tooltip title="Nuevo">
															<img src={ AlertIcon } className="alert-icon" />
														</Tooltip>
													)
												}
												{ moment(item?.created_at).format('DD-MM-YYYY') }
											</td>
											<td>{ item?.user?.name }</td>
											<td>{ item?.user?.city?.name }</td>
											<td>
												<Tooltip title="Ver">
													<a target="_blank" className="link-icon" href={ Constants.BASE_STORAGE + item?.file } onClick={ () => this.view(item,index) }>
														<img src={ EyeBlackIcon } />
													</a>
												</Tooltip>
											</td>
										</tr>
									)
								})
							}
						</Table>
					)
				}
				{
					this.state.item?.responses.length == 0 && (
						<p className="no-items">No se han recibido cotizaciones</p>
					)
				}
				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalView);